export const storefrontColors = ["#1c4585", "#c2410c", "#b91c1c", "#15803d", "#7c3aed", "#1b2430"] as const;
export type StorefrontAppearance = {
	displayName: string;
	tagline: string;
	logoUrl: string;
	coverUrl: string;
	accent: string;
	layout: "list" | "grid2" | "grid3";
	announcement: string;
};
export const defaultStorefrontAppearance: StorefrontAppearance = {
	displayName: "",
	tagline: "",
	logoUrl: "",
	coverUrl: "",
	accent: "#1c4585",
	layout: "list",
	announcement: "",
};
export function storefrontImageUrl(value: string) {
	if (!value) return "";
	if (/^https?:\/\//i.test(value)) return value;
	if (!value.startsWith("/uploads/")) return "";
	return (process.env.REACT_APP_API_URL || "http://localhost:3001/api").replace(/\/api\/?$/, "") + value;
}
